export default () => ({
  points: {},
  selectedTripKey: null,
  selectedVehicleTrip: {},
  trips: {},
  tripsLoading: false,
  tripsPromise: null,
  viewedVehicleTripKey: null,
  viewedVehicleTrip: {},
});
